import { useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { LoadingState } from "../components/LoadingState";
import { MarketContext } from "../components/MarketContext";
import { ReportBody } from "../components/ReportBody";
import { ReportQuickTake } from "../components/ReportQuickTake";
import { UnavailableState } from "../components/UnavailableState";
import { useFtmDataService } from "../context/FtmDataServiceContext";
import { useFtmResource } from "../hooks/useFtmResource";
import { categoryLabel, stateLabel } from "../lib/reportView";
import { formatTimestamp } from "../lib/format";
import type { Report } from "../types";

export function ReportDetailPage() {
  const { slug = "" } = useParams();
  const service = useFtmDataService();
  const loadReport = useCallback(() => service.getReport(slug), [service, slug]);
  const { data: report, loading, error } = useFtmResource(loadReport);

  if (loading) return <LoadingState label="Opening the FTM Report." />;
  if (error) return <UnavailableState title="Report could not load." message={error} />;
  if (!report) return <UnavailableState title="Report not found." message="This public snapshot does not contain a report for this address." />;

  return <main id="main-content" className="site-shell page-space report-detail-page">
    <Link className="back-link" to="/reports">← Back to Reports</Link>
    <header className="report-detail-header"><div className="report-detail-heading"><div className="report-detail-meta"><span className="tag">{categoryLabel(report.category)}</span><span className="tag">{stateLabel(report.state)}</span></div><h1 className="page-title">{report.title}</h1><MarketContext report={report} /><p className="report-detail-dek">An FTM Report compares public market probability with an independent range, then shows the evidence that moved the view.</p></div><div className="report-detail-aside"><div className="report-detail-aside-row"><span>Published</span><strong>{formatTimestamp(report.publishedAt ?? null)}</strong></div><div className="report-detail-aside-row"><span>Last reviewed</span><strong>{formatTimestamp(report.lastReviewedAt ?? null)}</strong></div><div className="report-detail-aside-row"><span>Platforms</span><strong>{report.platforms.map((platform) => platform.name).join(" · ") || "Unavailable"}</strong></div></div></header>
    <ReportQuickTake report={report} />
    <ReportBody report={report} />
  </main>;
}
